import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=b3b85b42&scoped=true&"
import script from "./SearchView.vue?vue&type=script&lang=js&"
export * from "./SearchView.vue?vue&type=script&lang=js&"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=b3b85b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b85b42",
  null
  
)

export default component.exports